import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const getBadgeColor = (badge) => {
    switch(badge) {
      case 'bestseller': return 'bg-[#c00000] text-white';
      case 'popular': return 'bg-white text-black';
      case 'limited': return 'bg-yellow-500 text-black';
      case 'new': return 'bg-green-500 text-white';
      default: return 'bg-[#c00000] text-white';
    }
  };

  const getBadgeText = (badge) => {
    switch(badge) {
      case 'bestseller': return 'BEST SELLER';
      case 'popular': return 'POPULAR';
      case 'limited': return 'LIMITED';
      case 'new': return 'NEW';
      default: return badge?.toUpperCase();
    }
  };

  return (
    <Link 
      to={`/product/${product.slug}`}
      className="group block"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#121212]">
        <img
          src={product.images[0]}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {/* Badges */}
        <div className="absolute top-4 left-4 flex flex-col gap-2">
          {product.badge && (
            <span className={`text-xs font-heading tracking-wider px-3 py-1 ${getBadgeColor(product.badge)}`}>
              {getBadgeText(product.badge)}
            </span>
          )}
          {product.is_reflective && (
            <span className="bg-[#c00000] text-white text-xs font-heading tracking-wider px-3 py-1">
              REFLECTIVE
            </span>
          )}
        </div>
        {product.original_price && (
          <span className="absolute top-4 right-4 bg-white text-black text-xs font-heading tracking-wider px-3 py-1">
            SALE
          </span>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        
        {/* Quick info on hover */}
        <div className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="flex items-center gap-2 text-white/80 text-xs">
            <span>Free Shipping</span>
            <span>•</span>
            <span>14-Day Returns</span>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <h3 className="font-heading font-bold text-base md:text-lg tracking-wide text-white group-hover:text-[#c00000] transition-colors uppercase">
          {product.name}
        </h3>
        <div className="flex items-center gap-3 mt-2">
          <span className="font-heading font-bold text-lg text-[#c00000]">
            {product.price} RON
          </span>
          {product.original_price && (
            <span className="font-body text-sm text-white/30 line-through">
              {product.original_price} RON
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
